


















import Vue from 'vue'
import Component from 'vue-class-component'
import {MessageListModes, MutationTypes} from '@/modules/i18n/store/mutations'
import {Action, Mutation, State} from 'vuex-class'

/**
 * Muestra una pantalla para la confirmación de eliminar una traducción
 *
 * @author Alejandro G. Riaño <agutierrez@softcontrol.es>
 */
@Component
export default class MessageDeletionConfirmComponent extends Vue {

    @State(state => state.i18n.messageList.mode)
    public mode: MessageListModes

    @Action('i18n/deleteSelectedMessage')
    public deletedSelectedMessage: () => void

    @Mutation(`i18n/${MutationTypes.SetLocaleMessageMode}`)
    public setMode: (payload: {mode: MessageListModes}) => void

    get isDeleting (): boolean {
        return this.mode === MessageListModes.Deleting
    }

    public deleting = false

    public cancel () {
        this.setMode({mode: MessageListModes.None})
    }

    /**
     * Método ejecutado cuando el usuario confirma que quiere eliminar
     * el mensaje.
     */
    public async confirm () {
        this.deleting = true
        await this.deletedSelectedMessage()
        this.setMode({mode: MessageListModes.None})
        this.deleting = false
    }
}
